import { routePaths } from 'components/Routes/data';
import { WizardHeader, WizardWrapper } from 'components/WizardViews/components';
import { WizardInfoProvider } from 'components/WizardViews/providers';
import React, { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { GeneralDetailsStep } from '../CreatePerquisites';
import { useQuery } from 'react-query';
import { salaryComponentParams } from 'components/SalaryComponents/constants';
import getPerquisiteComponent from 'api/gql-utils/perquisitesComponents/getPerquisiteComponent';
import { AppError } from 'utils/AppError';
import {
  PayrollGetPerquisiteComponentResponse,
  PerquisitesComponent,
} from 'api/gql-utils/perquisitesComponents/types';
import { FormProvider } from 'forms';

const EditPerquisitesForm = () => {
  const currentStep = 1;
  const history = useHistory();
  const search = new URLSearchParams(window.location.search);
  const componentId = search.get(salaryComponentParams.componentId) || '';
  const [isError, setIsError] = useState<boolean>(false);

  const handleCloseClick = () => {
    history.push(routePaths.salaryComponents.perquisitesListView);
  };

  const {
    data = null,
    isLoading,
    refetch,
  } = useQuery<PayrollGetPerquisiteComponentResponse, AppError, PerquisitesComponent>({
    queryKey: ['getPerquisiteComponent', componentId],
    queryFn: () => getPerquisiteComponent({ id: componentId || '' }),
    select(data) {
      return data?.payrollGetPerquisiteComponentDetails?.data;
    },
    onError(err) {
      setIsError(true);
    },
  });
  const initialValues = data
    ? {
        name: data.name,
        displayName: data.displayName,
        description: data.description,
        isSystemDefault: data.isSystemDefault,
        status: data.status,
        showZero: data.showZero,
        visibleToEmployee: data.visibleToEmployee,
        taxDeductionBehaviour: data.taxDeductionBehaviour ?? 'pro_rated',
        isTaxable: undefined,
        id: data.id,
        source: 'USER' as const,
        defaultFormula: undefined,
        componentType: undefined,
      }
    : undefined;

  return (
    <WizardInfoProvider initialStep={currentStep} totalSteps={1}>
      <WizardWrapper>
        <WizardHeader
          heading="Edit"
          subHeading="Perquisite component"
          onCloseClick={handleCloseClick}
        />
        {/* Prefill from existing component data */}
        <FormProvider>
          <GeneralDetailsStep
            initialValues={initialValues}
            isLoading={isLoading}
            isError={isError}
            onRefresh={refetch}
          />
        </FormProvider>
      </WizardWrapper>
    </WizardInfoProvider>
  );
};

export default EditPerquisitesForm;
